import type { VendorApiType } from './names';

// 3 bytes (24-bit) of entropy assumes a low tens of vendor-api entries per
// type per install: even at ~100 entries the collision probability is
// negligible (~0.03%), while keeping the slug short.
const SUFFIX_BYTES = 3;

function randomHexSuffix(byteLength: number): string {
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(byteLength));
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join(
    '',
  );
}

export function generateDefaultVendorApiSlug(type: VendorApiType): string {
  return `${type}-${randomHexSuffix(SUFFIX_BYTES)}`;
}
